function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusFs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16pt",
    height: "16pt",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.277344 11.335938 C 11.832031 12.582031 9.996094 13.332031 8 13.332031 C 6.003906 13.332031 4.167969 12.578125 2.722656 11.332031 C 1.496094 10.277344 0.667969 8.941406 0.667969 8 C 0.667969 7.058594 1.496094 5.722656 2.71875 4.667969 C 4.167969 3.421875 6 2.667969 8 2.667969 C 10 2.667969 11.835938 3.417969 13.28125 4.664062 C 14.503906 5.722656 15.332031 7.054688 15.332031 8 C 15.332031 8.945312 14.503906 10.277344 13.277344 11.335938 Z M 3.589844 10.324219 C 4.808594 11.371094 6.339844 12 8 12 C 9.660156 12 11.191406 11.371094 12.410156 10.324219 C 13.371094 9.496094 14 8.480469 14 8 C 14 7.519531 13.371094 6.503906 12.410156 5.675781 C 11.195312 4.628906 9.664062 4 8 4 C 6.335938 4 4.804688 4.628906 3.589844 5.675781 C 2.628906 6.503906 2 7.519531 2 8 C 2 8.480469 2.628906 9.496094 3.589844 10.324219 Z M 10.667969 8 C 10.667969 9.472656 9.472656 10.667969 8 10.667969 C 6.527344 10.667969 5.332031 9.472656 5.332031 8 C 5.332031 6.527344 6.527344 5.332031 8 5.332031 C 9.472656 5.332031 10.667969 6.527344 10.667969 8 Z M 8 6.667969 C 7.261719 6.667969 6.667969 7.261719 6.667969 8 C 6.667969 8.738281 7.261719 9.332031 8 9.332031 C 8.738281 9.332031 9.332031 8.738281 9.332031 8 L 9 8 C 8.449219 8 8 7.550781 8 7 Z M 8 6.667969 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFs);
export default __webpack_public_path__ + "static/media/statusFS.2d00e5a7eeb470b46f462e016a356f0e.svg";
export { ForwardRef as ReactComponent };